export const dashboardModule = {
    slug: 'dashboard',
    label: 'Dashboard',
    description: 'Live fleet overview: connected agents, recent requests, server health.',
    icon: 'Activity',
};
//# sourceMappingURL=dashboard.js.map